const category = document.querySelector('.category');
const controlTogglerActiveClass = 'filter-control__toggler_active';
const controlTogglersHolder = document.querySelector('.filter-control__toggler-holder');

function switchCategoryView(el) {
  const category = el;
  const positionsArr = Array.from(el.querySelectorAll('.pos'));

  function setTileView() {
    category.classList.add('category_type_cols');
    positionsArr.forEach((positionsArrEl) => {
      positionsArrEl.classList.add('pos_type_col');
    });
  }

  function setListView() {
    category.classList.remove('category_type_cols');
    positionsArr.forEach((positionsArrEl) => {
      positionsArrEl.classList.remove('pos_type_col');
    });
  }

  return {
    setListView,
    setTileView,
  };
}

function toggleClassName(targetBtn, siblingBtn, className) {
  targetBtn.classList.add(className);
  siblingBtn.classList.remove(className);
}

if (controlTogglersHolder) {
  const categoryViewSwitcher = switchCategoryView(category);
  const togglerBtnList = controlTogglersHolder.querySelector('.filter-control__toggler_type_list');
  const togglerBtnTile = controlTogglersHolder.querySelector('.filter-control__toggler_type_tile');

  togglerBtnList.addEventListener('click', (e) => {
    categoryViewSwitcher.setListView(category);
    toggleClassName(e.target, togglerBtnTile, controlTogglerActiveClass);
  });

  togglerBtnTile.addEventListener('click', (e) => {
    categoryViewSwitcher.setTileView(category);
    toggleClassName(e.target, togglerBtnList, controlTogglerActiveClass);
  });
}

$(document).on('click','form.pos .btn[data-entity="panel-add-button"],.detail__main-box .btn[data-entity="panel-add-button"]',function(){
  var t = this;
  setTimeout(function(){ 
      jQuery.ajax({
        url:     "/local/templates/symbiosislab/ajax/cart_count.php",
        type:     "POST", 
        dataType: "html", 
        data: "getcount", 
        success: function(response) { 
          $('.header__minicart .header__count').text(response);
    },
    error: function(response) { //Если ошибка
      console.log(response);
    }
    }); 
  },500);

  $(t).parents('form:first').find('.pos__footer .btn_bg_brand:first').show();
  $(t).parents('form:first').find('.pos__footer div[data-type="buy_btn"]').hide();   

  // for detail page
  $('.detail__main-box .btn.btn_bg_brand').show();
  $('.detail__main-box .btn[data-entity="panel-add-button"]').hide();   
});

$(document).on('click','.pos .toggler-title_type_param',function(){
      var cart1 = $(this).parents('form:first').find('.pos__footer .btn_bg_brand:first');
      var cart0 = $(this).parents('form:first').find('.pos__footer div[data-type="buy_btn"]');
      var ID = $(this).prev().attr("data-offer-id");
      jQuery.ajax({ 
        url:     "/local/templates/symbiosislab/ajax/if_in_cart.php", 
        type:     "POST", 
        dataType: "html",
        data: "ID="+ID, 
        success: function(response) { 
          //console.log(response);
          if (response=='1') {
            $(cart1).show();
            $(cart0).hide();
          }else {
            $(cart1).hide(); 
            $(cart0).show();
          }
    },
    error: function(response) { 
      console.log(response);
    }
    });
});




var ids;
jQuery.ajax({ 
  url:     "/local/templates/symbiosislab/ajax/get_ids_in_cart.php",
  type:     "POST", 
  dataType: "html",
  data: "getid", 
  success: function(response) {  
    if (response!='') {
        ids = Object.values(JSON.parse(response));

        $('.category form.pos, .tab-content form.pos').each(function(){  
          var cart1 = $(this).find('.pos__footer .btn_bg_brand:first');
          var cart0 = $(this).find('.pos__footer div[data-type="buy_btn"]');
        
          if ($(this).attr('data-id')!== undefined) { 
            if(jQuery.inArray($(this).attr('data-id'), ids) !== -1){
              $(cart1).show(); 
              $(cart0).hide();
            }else {
              $(cart1).hide(); 
              $(cart0).show(); 
            }        
          }else {
            id = $(this).find('.toggler:checked').attr("data-offer-id");
            
            if(jQuery.inArray(id, ids) !== -1){
              $(cart1).show(); 
              $(cart0).hide();
            }else {
              $(cart1).hide(); 
              $(cart0).show(); 
            }  
          } 
        });
    } 
}, 
error: function(response) { 
  console.log(response);
}
});

//search
$('.header__search-form').submit(function(e){
	e.preventDefault();
	var cur = window.location.href.split('?')[0];
	var sect = 'catalog/';
	
	if (cur.indexOf("/catalog/")>=0 && !$('.detail').length)  
		sect = '';
	else {
		cur = ''; 
		sect = '/catalog/';
	}
 
	if ($(this).find('input[name="search"]').val().length>2) 
		window.location.href=cur+sect+'?f='+$(this).find('input[name="search"]').val();
  
});